import React from 'react'
import PropTypes from 'prop-types'
import { Container, Input } from 'components/UIElements'
import STRINGS from 'utils/strings'
import Subheader from '../../../components/Subheader'

function VisitFields(props) {
  const {
    children,
    visitTemplate,
    errors,
    disabled,
    updateVisitName,
    studyLock,
    isArmsSupported = false,
    armInputError,
    setArmInputError,
    studyVisitSchedule,
    isReadOnlyState,
  } = props
  const { name: visitName } = visitTemplate
  const { name: nameErr } = errors || {}

  return (
    <Container>
      <div className='visit-fields'>
        <Subheader
          subheaderText={`1. ${isArmsSupported ? STRINGS.armNameQuestion : STRINGS.visitScheduleVistNameQuestion}`}
        />
        <div className='names'>
          <Input
            label={isArmsSupported ? STRINGS.armName : STRINGS.visitTemplateName}
            disabled={disabled || studyLock || isReadOnlyState}
            id='visit-name-input'
            className='visit-name-input'
            placeholder={isArmsSupported ? STRINGS.armName : STRINGS.visitName}
            value={visitName || ''}
            onChange={value => {
              updateVisitName(value)

              let existingArm = studyVisitSchedule?.find(arm => arm?.name === value)

              if (!!existingArm) {
                setArmInputError(STRINGS.armNameTaken)
              } else {
                setArmInputError('')
              }
            }}
            spellCheck
            charLimit={100}
            hasError={(nameErr && !visitName) || !!armInputError}
            errorText={nameErr || armInputError}
          />
        </div>
        {children}
      </div>
    </Container>
  )
}

VisitFields.propTypes = {
  disabled: PropTypes.bool,
  studyLock: PropTypes.bool,
  visitTemplate: PropTypes.shape({ name: PropTypes.string }),
  errors: PropTypes.object,
  updateVisitName: PropTypes.func,
  name: PropTypes.string,
}

export default VisitFields
